import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { MatSelectChange } from "@angular/material/select";
import { AccountService } from "src/app/Services/AccountService/account.service";
import { IBaseDataList } from "src/app/Models/Interface/Base/base-data-list";
import { IBuyerUsers } from "src/app/Models/Interface/User/buyer-users";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";

@Component({
  selector: "app-shopping-as-client",
  templateUrl: "./shopping-as-client.component.html",
  styleUrls: ["./shopping-as-client.component.scss"],
})
export class ShoppingAsClientComponent implements OnInit {
  users = {} as IBaseDataList<IBuyerUsers[]>;
  selectedUserForm!: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<ShoppingAsClientComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private accountService: AccountService,
    public formBuilder: FormBuilder
  ) {}

  ngOnInit(): void {
    this.selectedUserForm = this.formBuilder.group({
      company: [null, [Validators.required]],
      user: [null, [Validators.required]],
    });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  getEmployees(event: MatSelectChange): void {
    this.users = {} as IBaseDataList<IBuyerUsers[]>;
    this.accountService
      .getEmployeeForShoppingAs(event.value.id, 2)
      .subscribe((res) => {
        this.users = res;
        if (this.users.data.length === 0) {
          this.selectedUserForm.controls["user"].setErrors({ noUsers: true });
        }
      });
  }

  onSubmit(): void {
    if (!this.selectedUserForm.valid) {
      return;
    }
    this.dialogRef.close(this.selectedUserForm.value);
  }
}
